module.exports = __webpack_public_path__ + "img/img_banner_index_03.e1c7365e.jpg";